export default "__VITE_ASSET__BHFAp3_W__"